import axios from 'axios';
import { globalURLS } from '../../Global/urls.js';

export interface AdsGenSponsorDetails {
    title?: string;
    logo?: string;
}

export interface AdsGenActionStyle {
    copy?: string;
    bgColor?: string;
    textColor?: string;
}

export interface AdsGenAction {
    type?: 'default' | 'externalRedirect' | string;
    default?: AdsGenActionStyle;
    success?: AdsGenActionStyle;
    externalRedirectUrl?: string;
    registerto_discussionid?: string;
}

export interface AdsGenFooter {
    heading?: string;
    subHeading?: string;
    hideDoctorsText?: boolean;
    config?: {
        hideBlur?: boolean;
        underlay?: boolean;
    };
}

export interface AdsGenCreative {
    id?: string;
    displayName?: string;
    banner?: string;
    resize?: 'cover' | 'stretch' | string;
    disableBannerClick?: boolean;
    disclaimerText?: string;
    sponsorDetails?: AdsGenSponsorDetails;
    footer?: AdsGenFooter;
    config?: {
        hideBlur?: boolean;
        underlay?: boolean;
    };
    action?: AdsGenAction;
}

export interface AdsGen {
    prim?: number | string;
    id: string;
    section: string;
    type: 'BannerBar' | 'CubeBar' | string;
    sponsorDetails?: AdsGenSponsorDetails | null;
    bannerAspectRatio?: number;
    name: string;
    data: AdsGenCreative[];
    startdate?: string | null;
    enddate?: string | null;
    priority?: number;
    isactive?: number;
    interval?: number;
    createdon?: string;
    modifiedon?: string;
}

export interface AdsGenPayload {
    id?: string;
    section: string;
    name: string;
    type?: string;
    sponsorDetails?: AdsGenSponsorDetails;
    bannerAspectRatio?: number;
    data?: AdsGenCreative[];
    startdate?: string | null;
    enddate?: string | null;
    priority?: number;
    isactive?: number;
    interval?: number;
}

const post = async <T>(endpoint: string, body: Record<string, unknown> = {}): Promise<T> => {
    const response = await axios.post(
        `${globalURLS.baseURL}${endpoint}`,
        body,
        globalURLS.config,
    );
    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Request failed');
    }
    return response.data.data as T;
};

export const getAdsGenSections = () => post<string[]>('ADgetAdsGenSections', {});

export const getAdsGen = (params: {
    id?: string;
    section?: string;
    isactive?: number | '';
    name?: string;
    limit?: number;
    offset?: number;
} = {}) =>
    post<AdsGen[] | AdsGen>('ADgetAdsGen', {
        ...(params.id ? { id: params.id } : {}),
        ...(params.section ? { section: params.section } : {}),
        ...(params.isactive !== undefined && params.isactive !== ''
            ? { isactive: params.isactive }
            : {}),
        ...(params.name?.trim() ? { name: params.name.trim() } : {}),
        limit: params.limit ?? 100,
        offset: params.offset ?? 0,
    });

export const getAdsGenList = async (params: {
    section?: string;
    isactive?: number | '';
    name?: string;
    limit?: number;
    offset?: number;
} = {}) => {
    const data = await getAdsGen(params);
    return Array.isArray(data) ? data : data ? [data] : [];
};

export const createAdsGen = (payload: AdsGenPayload) =>
    post<AdsGen>('ADcreateAdsGen', payload as unknown as Record<string, unknown>);

export const updateAdsGen = (payload: AdsGenPayload & { id: string }) =>
    post<AdsGen>('ADupdateAdsGen', payload as unknown as Record<string, unknown>);

export const deleteAdsGen = (id: string, hardDelete = false) =>
    post<AdsGen | { id: string }>('ADdeleteAdsGen', { id, hardDelete });
